import React from 'react';
import { useSelector } from 'react-redux';

import EstimationResult from '../../../../../../shared/EstimationResult';

const FunnelEstimation = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { user } = useSelector((state) => state.user);
  const { estimationFolder } = useSelector((state) => state.sellerEstimationFolders);
  

  if (!sale.id) return null;
  
  return (
    <div data-testid='FunnelEstimation'>
      <EstimationResult sale={{ ...sale, owner: user, estimation_folder: estimationFolder }} />
    </div>
  );
}

export default FunnelEstimation;
